<script setup lang="ts">
import { computed, defineProps, ref } from "vue";
import type { PropType } from 'vue';
import type { BrandPosition } from './brandLayout';
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const props = defineProps({
  brands: {
    type: Array,
    default: () => []
  },
  layoutImage: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  value: {
    type: Array  as PropType<typeof BrandPosition[]>,
    default: () => []
  }
})

const selectedBrandId = ref(null);
const points = ref<BrandPosition[]>(props.value);
const currentPoint = computed(() => {
  return points.value.find((point) => point.brand_id === selectedBrandId.value);
});

console.log('points', points.value);
const handleImageClick = (event) => {
  showModal.value = false;
  if (!selectedBrandId.value) {
    return;
  }
  const rect = event.target.getBoundingClientRect();
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;
  // check if point already exists for selected brand
  const existingPoint = points.value.findIndex((point) => point.brand_id === selectedBrandId.value);
  if (existingPoint !== -1) {
    points.value[existingPoint] = {
      brand_id: selectedBrandId.value,
      x,
      y
    };
  } else {
    points.value.push(<BrandPosition>{
      brand_id: selectedBrandId.value,
      x,
      y
    });
  }
}

const showModal = ref(false);
const onSelectBrand = (brandId:any) => {
  selectedBrandId.value = brandId;
  showModal.value = true;
}
const onResetBrand = (brandId:any) => {
  const index = points.value.findIndex((point) => point.brand_id === brandId);
  if (index !== -1) {
    points.value.splice(index, 1);
  }
}

const stringifyPoints = computed(() => {
  return JSON.stringify(points.value);
})
const onUpdateDialog = (isOpen: Boolean) => {
  showModal.value = isOpen;
}

</script>
<template>
  <div class="row">
    <div v-for="brand in props.brands" :key="brand.id" class="parent col-12 col-sm-6 col-md-4 d-flex items-center justify-content-start mb-2">
      <div class="mr-2">
        <i :class="[
          'fa fa-location-arrow',
          points.some((point) => point.brand_id === brand.id) ? 'text-success' : 'text-muted'
        ]" aria-hidden="true"></i>
      </div>
      <a href @click.prevent="onSelectBrand(brand.id)" :class="[
        'mr-auto',
        points.some((point) => point.brand_id === brand.id) ? 'text-success' : 'text-muted'
      ]">
        {{ brand.name }}
      </a>
      <a
        v-if="points.some((point) => point.brand_id === brand.id)"
        href @click.prevent="onResetBrand(brand.id)" class="visible-on-hover  text-danger">
        reset
      </a>
    </div>
  </div>
  <input type="hidden" :name="props.name" :value="stringifyPoints">

  <Dialog :open="showModal" @update:open="onUpdateDialog">
    <DialogScrollContent size="xl">
      <DialogHeader>
        <DialogTitle>
          {{ $t('Select position') }}
        </DialogTitle>
      </DialogHeader>
      <div style="height: 800px" class="overflow-auto">
        <div style="width: 1200px; position: relative;">
          <img
            :src="props.layoutImage"
            alt="layout"
            class="img-fluid"
            @click="handleImageClick"
            style="cursor: pointer;"
          />
          <!-- Overlay Points -->
          <div
            v-for="point in points"
            :key="point.brand_id"
            :style="{
              position: 'absolute',
              top: `${point.y}px`,
              left: `${point.x}px`,
              width: '20px',
              height: '20px',
              backgroundColor: 'blue',
              borderRadius: '50%',
              transform: 'translate(-50%, -50%)'
            }"
          ></div>
          <div
            v-if="currentPoint"
            :style="{
              position: 'absolute',
              top: `${currentPoint.y}px`,
              left: `${currentPoint.x}px`,
              width: '30px',
              height: '30px',
              backgroundColor: 'red',
              borderRadius: '50%',
              transform: 'translate(-50%, -50%)'
            }"
          ></div>
        </div>
      </div>
    </DialogScrollContent>
  </Dialog>
</template>
<style scoped>
  .parent .visible-on-hover { visibility: hidden; }
  .parent:hover .visible-on-hover { visibility: visible; }
</style>
